* {
  box-sizing: border-box;
  --label-width-percentage: 10%;
  --value-width-percentage: 90%;
}

:host {
  display: block;
  max-width: 100%;

  gz-title[id='title'],
  gz-text[id='title-maintenance-details'] {
    margin-bottom: calc(var(--spacer) * 2);
  }

  gz-text[id='title-maintenance-details'] {
    color: var(--chart-300-icon-buttons);
  }

  gz-text {
    line-height: 1.15;
  }
}

.wrapper {
  padding: 2px;
  display: block;

  &.is-loading {
    padding-top: calc(var(--spacer) * 20);

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }
  &.is-error {
    padding-top: calc(var(--spacer) * 3);
  }
}

.details-container:not(:last-child) {
  margin-bottom: calc(var(--spacer) * 6);
}

.details-container:last-child {
  margin-bottom: calc(var(--spacer) * 2);
}

.details-container {
  padding: calc(var(--spacer) + 2px) calc(var(--spacer) + 2px) calc(var(--spacer) - 3px) calc(var(--spacer) + 2px);
  border-left: 6px solid var(--blue-layout-200-disabled);
}

.loaded-content {
  display: block;
  margin-top: calc(var(--spacer) * 4);
}

gz-progress-spinner {
  display: none;
}

gz-image-repo[state='error'] {
  display: none;
}

.is-loading {
  gz-progress-spinner {
    display: block;
  }
  .loaded-content {
    display: none;
  }
}

.is-error {
  gz-image-repo[state='error'] {
    display: block;
  }
  .loaded-content {
    display: none;
  }
}

@media screen and (max-width: 1536px) {
  * {
    --label-width-percentage: 16%;
    --value-width-percentage: 84%;
  }
}
